<template>
  <!-- Grid Text image -->
  <section class="videoFullSection">
    <video
      ref="videoElement"
      :poster="shopifyData.poster"
      autoplay
      loop
      muted
      controlsList="nodownload"
      disablepictureinpicture
      webkit-playsinline
      playsinline
      preload="auto"
      controls
    >
      <source :src="shopifyData.videolink" />
    </video>
    <h2 class="main_heading">
      {{ shopifyData.bottomTitle }}
    </h2>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoMuted: true, // Initialize video as muted
    };
  },
  mounted() {
    // Initialize IntersectionObserver
    const observer = new IntersectionObserver(this.handleIntersection, {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.5, // When at least 50% of the element is visible
    });

    // Observe the video section
    const videoSection = this.$refs.videoElement;
    if (videoSection) {
      observer.observe(videoSection);
    }
  },
  methods: {
    handleIntersection(entries) {
      // Check if the video section is in the viewport
      const videoSection = this.$refs.videoElement;
      if (!videoSection) return;

      const videoIsInViewport = entries[0].isIntersecting;
      const isMobile = window.innerWidth <= 575;

      if (videoIsInViewport) {
        this.videoMuted = false;
        videoSection.muted = this.videoMuted;
        if (isMobile) {
          videoSection.setAttribute('controls', true);
        }
      } else {
        this.videoMuted = true; // Mute the video
        videoSection.muted = this.videoMuted;
      }
    },
  },
};
</script>

<style scoped>
.main_heading {
  color: #000;
  font-family: 'Big Caslon', serif;
  font-size: 56px;
  font-style: normal;
  font-weight: 500;
  margin: 60px 0;
  padding: 0 15px;
}

video {
  display: block;
}

@media only screen and (max-width: 767px) {
  .main_heading {
    font-size: 36px;
    margin: 30px 0;
    text-align: center;
    line-height: 1;
  }
}
</style>
